import React from 'react';
import styled, { css } from 'styled-components';
import {
    ProjectEditPageGrid as ProjectEditPageGridLib,
    ProjectEditPageGridRow as ProjectEditPageGridRowLib,
    ProjectEditPageGridLabel as ProjectEditPageGridLabelLib,
    ProjectEditPageGridStartLabel as ProjectEditPageGridStartLabelLib,
} from '@brg/ui';
import { LayoutConst } from 'core';

export const ProjectEditPageGrid = ProjectEditPageGridLib;

export const ProjectEditPageGridRow = styled(ProjectEditPageGridRowLib)`
    ${({ isProjectEdit }) => isProjectEdit && css`
        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            height: auto;
            max-height: none;
            min-height: 0;
        }
    `}
`;

export const ProjectEditPageGridLabel = styled(ProjectEditPageGridLabelLib).withConfig({
    shouldForwardProp: (prop) => prop !== 'labelColor' && (prop as string) !== 'heightAuto' && (prop as string) !== 'noMarginBottom',
})<{ labelColor?: string; heightAuto?: boolean; noMarginBottom?: boolean }>`
    color: ${({ theme, labelColor }) => labelColor || (theme as any)?.projectEdit?.label || 'inherit'};
    
    ${({ heightAuto }) => heightAuto ? css`
        height: auto;
    ` : css`
        height: 48px;

        @media (max-width: 1440px), (max-height: 920px) {
            height: 40px;
        }
        @media (max-width: 940px) {
            height: auto;
            margin-bottom: 8px;
        }
    `}

    ${({ noMarginBottom }) => noMarginBottom && css`
        margin-bottom: 0 !important;

        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            height: auto;
        }

        @media (max-width: ${LayoutConst.screen.m}px) {
            margin-bottom: 8px !important;
        }
    `}
`;

export const ProjectEditPageGridStartLabel = styled(ProjectEditPageGridStartLabelLib).withConfig({
    shouldForwardProp: (prop) => prop !== 'labelColor',
})<{ labelColor?: string }>`
    color: ${({ theme, labelColor }) => labelColor || (theme as any)?.projectEdit?.label || 'inherit'};
`;

import React from 'react';
import styled, { css } from 'styled-components';
import {
    ProjectEditPageGrid as ProjectEditPageGridLib,
    ProjectEditPageGridRow as ProjectEditPageGridRowLib,
    ProjectEditPageGridLabel as ProjectEditPageGridLabelLib,
    ProjectEditPageGridStartLabel as ProjectEditPageGridStartLabelLib,
} from '@brg/ui';
import { LayoutConst } from 'core';

export const ProjectEditPageGrid = ProjectEditPageGridLib;

export const ProjectEditPageGridRow = styled(ProjectEditPageGridRowLib)`
    ${({ isProjectEdit }) => isProjectEdit && css`
        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            height: auto;
            max-height: none;
            min-height: 0;
        }
    `}
`;

export const ProjectEditPageGridLabel = styled(ProjectEditPageGridLabelLib).withConfig({
    shouldForwardProp: (prop) => prop !== 'labelColor' && (prop as string) !== 'heightAuto' && (prop as string) !== 'noMarginBottom',
})<{ labelColor?: string; heightAuto?: boolean; noMarginBottom?: boolean }>`
    color: ${({ theme, labelColor }) => labelColor || (theme as any)?.projectEdit?.label || 'inherit'};
    
    ${({ heightAuto }) => heightAuto ? css`
        height: auto;
    ` : css`
        height: 48px;

        @media (max-width: 1440px), (max-height: 920px) {
            height: 40px;
        }
        @media (max-width: 940px) {
            height: auto;
            margin-bottom: 8px;
        }
    `}

    ${({ noMarginBottom }) => noMarginBottom && css`
        margin-bottom: 0 !important;

        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            height: auto;
        }

        @media (max-width: ${LayoutConst.screen.m}px) {
            margin-bottom: 8px !important;
        }
    `}
`;

export const ProjectEditPageGridStartLabel = styled(ProjectEditPageGridStartLabelLib).withConfig({
    shouldForwardProp: (prop) => prop !== 'labelColor',
})<{ labelColor?: string }>`
    color: ${({ theme, labelColor }) => labelColor || (theme as any)?.projectEdit?.label || 'inherit'};
`;

